export const MAX_ATTENDEES = 1000;
export const MAX_ATTENDEES_WEBCAST = 3000;
export const MAX_ATTENDEES_BREAKOUTS = 250;
export const MAX_REGISTRANTS_SUMULIVE = 30000;
